import { Box, Chip, Stack, Typography, useTheme } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { AlertStatus, timeLeft } from './AlertDetails.utils';

type StatusStatValueProps = {
  status: AlertStatus;
  startDate: Date | null;
  endDate: Date | null;
};

export const StatusStatValue = (props: StatusStatValueProps): JSX.Element => {
  const { status, startDate, endDate } = props;
  const { t } = useTranslation();
  const theme = useTheme();
  const activeChipColors =
    status === 'active'
      ? {
          backgroundColor: theme.palette.alert.action.main,
          color: theme.palette.alert.action.contrastText,
        }
      : undefined;

  if (status === 'expired') {
    return (
      <Chip
        label={t('alert.expired')}
        color="default"
        variant="watchduty-basic"
        size="small"
        sx={{
          fontSize: theme.typography.body1.fontSize,
          mt: 0.5,
        }}
      />
    );
  }

  const label = status === 'future' ? t('alert.future') : t('alert.active');
  const chipColor =
    status === 'future' || activeChipColors ? 'default' : 'primary';

  return (
    <Stack alignItems="center" spacing={0.5} sx={{ mt: 0.5 }}>
      <Chip
        label={label}
        color={chipColor}
        variant="watchduty-basic"
        size="small"
        sx={{
          fontSize: theme.typography.body1.fontSize,
          ...activeChipColors,
        }}
      />
      {status === 'active' && endDate && timeLeft(t, endDate) && (
        <Box>
          <Typography
            variant="subtitle1"
            color="textSecondary"
            fontWeight="fontWeightBold"
          >
            {timeLeft(t, endDate)}
          </Typography>
          <Typography variant="subtitle1" color="textSecondary">
            {t('alert.timeLeft')}
          </Typography>
        </Box>
      )}
      {status === 'future' && startDate && timeLeft(t, startDate) && (
        <Box>
          <Typography
            variant="subtitle1"
            color="textSecondary"
            fontWeight="fontWeightBold"
          >
            {timeLeft(t, startDate)}
          </Typography>
          <Typography variant="subtitle1" color="textSecondary">
            {t('alert.untilActive')}
          </Typography>
        </Box>
      )}
    </Stack>
  );
};
